import {Link} from "react-router-dom"
export const Footer = () => {
  return (
   <footer>
    <p>@ 2030 <Link to='/'>WriteBlog </Link>. All right Reserved-Made by Ayush sharma</p>
   </footer>
  )
}

